var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', _vm._b({}, 'v-card', _vm.$attrs, false), [_c('v-card-text', {
    staticClass: "caption"
  }, [_c('v-row', {
    staticClass: "ma-n4",
    staticStyle: {
      "word-break": "keep-all"
    }
  }, [_vm._l(_vm.items, function (_ref) {
    var term = _ref.term,
      desc = _ref.desc;
    return [_c('v-col', {
      key: term,
      staticClass: "py-3 px-4",
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "font-weight-bold grey--text"
    }, [_vm._v(_vm._s(term))]), _vm._v(" " + _vm._s(desc) + " ")])];
  }), _c('v-col', {
    staticClass: "py-3 px-4",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "font-weight-bold grey--text"
  }, [_vm._v("대상상품")]), _vm.usage.target.type == _vm.USAGE_TARGET_TYPES.ALLITEMS.value ? [_vm._v(" 전체 ")] : _vm._e(), _vm.usage.target.type == _vm.USAGE_TARGET_TYPES.PRODUCTS.value ? [_c('autocomplete-product', {
    attrs: {
      "value": _vm.usage.target._products,
      "multiple": "",
      "readonly": "",
      "placeholder": "없음"
    }
  })] : _vm._e(), _vm.usage.target.type == _vm.USAGE_TARGET_TYPES.CATEGORY.value ? [_c('autocomplete-category', {
    attrs: {
      "value": _vm.usage.target._categories,
      "multiple": "",
      "readonly": "",
      "placeholder": "없음"
    }
  })] : _vm._e(), _vm.usage.target.type == _vm.USAGE_TARGET_TYPES.DISPLAYS.value ? [_vm._v(" " + _vm._s(_vm.displayCodeTexts) + " ")] : _vm._e(), _vm.usage.target.type == _vm.USAGE_TARGET_TYPES.EXHIBITS.value ? [_c('autocomplete-exhibition', {
    attrs: {
      "value": _vm.usage.target._exhibitions,
      "multiple": "",
      "readonly": "",
      "placeholder": "없음"
    }
  })] : _vm._e()], 2)], 2)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }